var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmountCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    rx: 15.5,
    fill: "#EAFFEC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2857 12H12.7143C11.7675 12 11 12.8059 11 13.8V19.2C11 20.1941 11.7675 21 12.7143 21H21.2857C22.2325 21 23 20.1941 23 19.2V13.8C23 12.8059 22.2325 12 21.2857 12Z",
    stroke: "#25CE36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 18C17.8284 18 18.5 17.3284 18.5 16.5C18.5 15.6716 17.8284 15 17 15C16.1716 15 15.5 15.6716 15.5 16.5C15.5 17.3284 16.1716 18 17 18Z",
    stroke: "#25CE36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 12.2V10.6C19 10.1757 18.8344 9.76869 18.5397 9.46863C18.245 9.16857 17.8453 9 17.4286 9H9.57143C9.15466 9 8.75496 9.16857 8.46026 9.46863C8.16556 9.76869 8 10.1757 8 10.6V15.4C8 15.8243 8.16556 16.2313 8.46026 16.5314C8.75496 16.8314 9.15466 17 9.57143 17H11.1429",
    stroke: "#25CE36",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmountCardIcon);
export default __webpack_public_path__ + "static/media/amount_card_icon.f09c9749752f99fd680407e984480b85.svg";
export { ForwardRef as ReactComponent };